export default __webpack_public_path__ + "static/media/ctov3.ae5ce18d.png";